import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import { useContext, useState, useEffect, useRef } from "react";
import $ from "jquery";
import { ParcelReceiptTemplate,Data } from "./Template";
import WebAppApiService from '../../services/WebAppApiService'

// นำเข้า TinyMCE และปลั๊กอิน
import 'tinymce/tinymce'; // Core TinyMCE
import 'tinymce/themes/silver/theme'; // ธีม Silver (ค่าเริ่มต้น)
import 'tinymce/icons/default/icons'; // Icon set
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';

//import * from '../../assets/css/mystyles.css'
const PanelProductEdit = (props) => {
  const {
    title,
    subTextCount,
    isShowDescription,
    isEdit,
    active,
    ckEditorContent,
    isReadOnly,
    type,
    onProcessing,
    template,
    data,
    viewMode,
    height = 500,
    draw=0
  } = props;
  const [reportContentState, setReportContentState] = useState("");
  const [templateOrigin, settemplateOrigin] = useState("");
  const [apiKey, setApiKey] = useState("");
  const tinyEditor = useRef(null);
  let isFillTemplateComplete = false;

  useEffect(() => {

    WebAppApiService.editor().then((response)=>{

      setApiKey(response.editor);
      
    }).catch(error=>{
      setApiKey('test');
    })

  },[])

  useEffect(() => {
    let { template ,data} = props;  


    //console.log("template ==> ", template,data);
    // template =
    //   template === undefined || template === "" || template === null || true
    //     ? ''
    //     : template;
    let sdata = 
    data === undefined || data === "" || data === null
      ? Data
      : data;

    let currentContent = setDataToTemplate(initialTemplate(template),sdata);

    //console.log("currentContent xxx" ,currentContent)
    setReportContentState(currentContent);
    settemplateOrigin(template);
    const dom = $.parseHTML('<div class="A4">' + currentContent + "</div>");
    // let test = $(dom).getElementsByClassName("example")
    // console.log ("test " ,test)
    //console.log("dom 2==>",$($(dom).html())," currentContent ==>",currentContent);
  }, [props.data]);
  

  const setDataToTemplate = (template,data) => {
    let arr = [];

    //const dom = $.parseHTML(template);
    const dom = $.parseHTML('<div class="A4">' + template + '</div>')
    //console.log("dom.html",$(dom).html());
    arr = Object.keys(data).map(key => {

        //template = template.replaceAll("{"+ key  +"}"," " + data[key])
          if (key.substring(0,2) === 'b_'){
            $(dom).find('.'+key).attr("checked",data[key]==='true')
          } else {
            $(dom).find('.'+key).text(data[key])
          }
        }
        )
        return $(dom).html()
  };

  const getTemplateFromData = (text,data) => {
    let arr = [];
    const {viewMode} = props
    const dom = $.parseHTML(text);
    //console.log("dom.html",$(dom).html());
    arr = Object.keys(data).map(key => {
          //text = text.replaceAll(" " + data[key],"{"+ key  +"}")
          if (key.substring(0,2) === 'b_'){
            $(dom).find('.'+key).attr("checked",data[key]==='true')
          }
          else {
            $(dom).find('.'+key).text("{"+ key  +"}")
          }
        }
        )

        let htmlstring = `<div class="A4 water-mark water-mark-ie">` +  $(dom).html() + `</div>`
        //console.log("dom.html  to parent",htmlstring);
        return htmlstring;
      };


  // const { data: contextData, setData: setContextData } = useContext(
  //     TenderContext
  // )

  const handleEdit = (event) => {

  };

  const handlePreview = (event) => {

  };

  const loadEditorData = (editor) => {
    let currentContent = "";

    currentContent = setDataToTemplate(initialTemplate(reportContentState),data)
    // console.log(
    //   "loadEditorData currentContent",
    //   (currentContent || "").substring(0, 30)
    // );

    let tp = currentContent;
      setReportContentState(tp);
    if (editor) {
      isFillTemplateComplete = true;
      editor.setContent(tp);
    } else {
      mergeTemplateWithData(tp)
    }
  };
  const mergeTemplateWithData = (tp) => {
    isFillTemplateComplete = true;
    const templateMerged = tp; // fillTemplate(template)
    delayedEditor(templateMerged);
  };

  const delayedEditor = (text) => {
    let {data} = props 
    if (text !== "") {
      //console.log("delayedEditor text",text);
      //console.log("delayedEditor template",templateOrigin);
      setReportContentState(text);
      
      props.editChange(getTemplateFromData(text,data));
    } else {
      console.log("delayedEditor with no content");
    }
  };

  const checkIsReportDraft = (content) => {
    let userAgentString = navigator.userAgent;
    let IExplorerAgent =
      userAgentString.indexOf("MSIE") > -1 ||
      userAgentString.indexOf("rv:") > -1;
    let watermark = "water-mark";
    
    if (IExplorerAgent) {
      //IE
      watermark = "water-mark-ie";
      if (content.indexOf("water-mark-ie") === -1)
        content = content.replace("water-mark", "water-mark-ie");
    } else {
      if (content.indexOf("water-mark-ie") !== -1)
        content = content.replace("water-mark-ie", "water-mark");
    }

    if (content.indexOf('<div class="A4') == -1) {
      content = `<div class="A4">\n${content}\n</div>`;
    }

    const dom = $.parseHTML('<div class="A4">' + content + "</div>");
    //console.log(" dom ==>", $($(dom).html()));

    if (props.viewMode) {
        return $($(dom).html())
            .removeClass(watermark)
            .addClass('allTextColorBlack')[0].outerHTML
    } else {
        const replaceDom = $(dom)
        $('.water-mark-ie', replaceDom).removeClass('water-mark-ie')
        $('.water-mark', replaceDom).removeClass('water-mark')
        const innerHtml = replaceDom.html()

        return $('<div>')
            .append(
                $(innerHtml)
                    .removeClass('allTextColorBlack')
                    .addClass(watermark)
                    .clone()
            )
            .html()

    }
  };

  const initialTemplate = (content) => {
    let template = content;
    // if (documentInfomation.details.procurementMethod === 'วิธีพิเศษ') {
    //     template = template.replace('ผู้เสนอราคาที่ชนะการเสนอราคา ได้แก่', 'จาก')
    // }
    // let purchasingOrganization = publicRuntimeConfig.PurOrg.split(',')
    // let POrganization = purchasingOrganization.find(Org => {
    //     if (documentInfomation.details.purchasingOrganization.search(Org) !== -1) {
    //         return true;
    //     }
    // })
    // if (POrganization !== undefined) {
    //     let conditionAdd = template.search('พ.ศ. 2562 <span>และที่แก้ไขเพิ่มเติม</span> โดยวิธี<span data-template="true" class="purchasingCondition')
    //     let conditionAdd2 = template.search('พ.ศ. 2562 <span>และที่แก้ไขเพิ่มเติม</span> โดยวิธี<span class="purchasingCondition')
    //     if (conditionAdd === -1) {
    //         template = template.replace('พ.ศ. 2562 โดยวิธี<span data-template="true" class="purchasingCondition', 'พ.ศ. 2562 <span>และที่แก้ไขเพิ่มเติม</span> โดยวิธี<span data-template="true" class="purchasingCondition')
    //     }
    //     if (conditionAdd2 === -1) {
    //         template = template.replace('พ.ศ. 2562 โดยวิธี<span class="purchasingCondition', 'พ.ศ. 2562 <span>และที่แก้ไขเพิ่มเติม</span> โดยวิธี<span class="purchasingCondition')
    //     }
    // }
    return template;
  };
  //console.log("    console.log( reportContentState) ==> " , reportContentState);
  return (

    <>
      {/* &nbsp; &nbsp; &nbsp; &nbsp;
      <a
        className="sp-btn-icon"
        onClick={(event) => {
          handleEdit(event);
        }}
      >
        {" "}
   
        <i className="icon bt-edit" />
        <span className="sp-btn-icon-label">Edit</span>
      </a>{" "}
      &nbsp; &nbsp;
      <a
        className="sp-btn-icon"
        onClick={(event) => {
          handlePreview(event);
        }}
      >
        <i className="icon btn-print-orange2" />
        <span className="sp-btn-icon-label">Preview</span>
      </a> */}
      { templateOrigin && apiKey && <Editor
        apiKey={`${apiKey}`}
        value={reportContentState}

        ref={tinyEditor}
        onEditorChange={(text) => {

          delayedEditor(text)
        }}
        id={"tender-sumary-approver" + props.id}
        disabled={ckEditorContent === 2 ? true : false}
        init={{
          setup: function (editor) {
            // if (isReadOnly) {
            //   editor.setMode('design')
            // }
            editor.on("init", (e) => {
              console.log("editor init", e);
              var counter = 0;
              var i = setInterval(() => {
                const edt = tinyEditor?.current?.editor
                counter++;
                //console.log("init interval", counter);
                if (edt) {
                  const edtContent = edt.getContent()
                  if (edtContent !== '') {
                      clearInterval(i);
                      console.log('init interval data aleardyUpdate')
                  }
                  else if (edtContent === '' && reportContentState !== '') {
                      edt.setContent(reportContentState)
                      //setcontent
                      clearInterval(i);
                      console.log('init interval setContent', counter)
                  }
                  else {
                      console.log('init interval editorContent', (edtContent || '').substring(0, 30))
                      console.log('init interval reportContent', (reportContentState || '').substring(0, 30))
                  }
              } else {
                  console.log('init interval editor undefined')
              }
                if (counter === 10) {
                  clearInterval(i);
                  console.log("init interval clear interval");
                }
              }, 500);

              loadEditorData()
            });
            editor.on("Change", (e) => {});

            editor.on("SetContent", (e) => {
              console.log("editor SetContent current content",e, (editor.getContent() || "").substring(0, 30));
            });
            editor.on("BeforeSetContent", (e, a) => {
              console.log( "editor BeforeSetConten initial load set",e.initial,e.load,e.set);
              //console.log("editor BeforeSetContent e.content",(e.content || "").substring(0, 30));
            });
            console.log("setup isReadOnly", props.viewMode);
            if (props.viewMode) {
              editor.on("PreInit", function (event) {
                const ed = event.target,
                  dom = editor.dom;

                dom.setAttrib(ed.getBody(), "contenteditable", "false");
              });
            }
            editor.on("init keydown", function (e) {
              if (e.keyCode == 9) {
                editor.execCommand(
                  "mceInsertContent",
                  false,
                  "<span>&emsp;&emsp;</span>"
                );
                return;
              }
              if (
                e.keyCode === 13 /* Enter key */ ||
                e.keyCode === 8 /* Backspace key */ ||
                /* del key */ e.keyCode == 46
              ) {
                editor.focus();
                const htmlSelection = editor.selection.getContent();
                console.log("htmlselect ==> ",htmlSelection);
                if (htmlSelection.includes("contenteditable")) {
                  return false;
                }
              }
            });
            // editor.ui.registry.addButton('customPrintPreview', {
            //     icon: 'print',
            //     tooltip: 'Print',
            //     onAction: function (_) {
            //         onProcessing ? onProcessing(true) : editor.setProgressState(true)
            //         //handleOnEditorPrint(editor)
            //     },
            //   }
            //   );
          },
          paste_as_text: true,
          verify_html: false,
          height: height ? height : 500,
          width: "100%",
          menubar: false,
          statusbar: false,
          content_css: '../../assets/css/mystyles.css',
          // plugins: [
          //     'advlist autolink lists link image charmap print preview anchor',
          //     'searchreplace visualblocks code fullscreen pagebreak hr code',
          //     'insertdatetime media table paste code table '
          // ],
          // fontsize_formats:
          //     '8px 10px 12px 14px 16px 18px 24px 36px',
          toolbar: ["customPrintPreview"], // isReadOnly
          //     ? ['customPrintPreview']
          //     : [
          //           'undo redo | formatselect fontsizeselect | bold italic underline strikethrough |  forecolor backcolor | alignleft aligncenter alignright alignjustify',
          //           'bullist numlist outdent indent | searchreplace removeformat blockquote | pagebreak hr table | code customPrintPreview'
          //       ]
          base_url: '/tinymce',
          suffix: '.min'
        }}
      />}
    </>
  );
};

export default PanelProductEdit;
